module.exports = __webpack_public_path__ + "img/fig22.9d61187f.jpg";